const { compose, scale: mScale, translate: mTranslate } = window.TransformationMatrix;

import { Widget } from "./widget.js";
import { CanvasLayerImage } from "./remix-document.js";
import { Dialog } from "./widgets.js";
import EmoteList from "./emotes.js";


function recentlyUsedEmote(emoteId)
{
    let data = getRecentlyUsedEmotes();
    let now = Date.now();
    data[emoteId] = now;
    localStorage.setItem("recentlyUsedEmotes", JSON.stringify(data));
}

function getRecentlyUsedEmotes()
{
    let data = localStorage.getItem("recentlyUsedEmotes");
    if(!data)
        return {};

    try {
        return JSON.parse(data);
    } catch(e) {
        console.error("Error parsing recentlyUsedEmotes:", e);
        return {};
    }
}

export class AddEmoteDialog extends Dialog
{
    constructor({ remixDocument, ...rest })
    {
        super({
            contents: `
    <div class="emote-dialog">
        <div class=emote-list>
        </div>
    </div>
`, ...rest});
        let emoteListNode = this.root.querySelector(".emote-list");
        this.emoteList = new EmoteButtonList({
            parentNode: emoteListNode,
            onclick: async(emoteId) => {
                console.log("Emote selected:", emoteId, remixDocument);

                let emoteInfo = EmoteList.emotes.find(e => e.id.toString() === emoteId);
                if(!emoteInfo)
                {
                    console.error("Emote not found:", emoteId);
                    return;
                }

                let emoteLayer = new CanvasLayerImage({
                    name: emoteInfo.name,
                    src: emoteInfo.path,
                    width: emoteInfo.width, height: emoteInfo.height,
                });

                // The default position will align the image at the top-left.  Shift to center
                // it around the origin, then down and right to center.
                let { width, height } = emoteLayer.unscaledSize;

                // Compute a uniform scale so the closer (limiting) dimension is 50% of the canvas.
                let s = Math.min(0.5 * remixDocument.width / width, 0.5 * remixDocument.height / height);
                let x = (remixDocument.width  * 0.5) - (width * s * 0.5);
                let y = (remixDocument.height * 0.5) - (height * s * 0.5);
                
                emoteLayer.matrix = compose(
                    mTranslate(x, y),
                    mScale(s, s),
                );

                remixDocument.addLayer(emoteLayer);
                remixDocument.selectedLayer = emoteLayer;
                recentlyUsedEmote(emoteId);

                this.close();
            },
        });
    }
}

class EmoteButtonList extends Widget
{
    constructor({ 
        onclick,
        ...rest
    })
    {
        super({
            html: `
            <div>
                <div class=search-container>
                    <input class=search type=text placeholder="Search emotes...">
                </div>
                <div class=emote-list></div>
            </div>
            `,
        ...rest});

        this.onclick = onclick;
        this.filter = "";

        EmoteList.addEventListener("refresh", () => this.refresh(), { signal: this._signal });
        this._emoteListNode = this.root.querySelector(".emote-list");

        this._emoteListNode.addEventListener("click", (e) => {
            let button = e.target.closest(".emote-button");
            if(!button)
                return;

            if(!button.dataset.emoteId)
                return;

            this.onclick?.(button.dataset.emoteId);
        }, { signal: this._signal });

        let searchButton = this.root.querySelector(".search");;
        searchButton.addEventListener("input", (e) => {
            this.filter = e.target.value.toLowerCase();
            this.refresh();
        }, { signal: this._signal });
        
        this.refresh();
        searchButton.focus();
    }

    refresh()
    {
        console.log("Refreshing emote button list");
        while(this._emoteListNode.firstElementChild)
            this._emoteListNode.firstElementChild.remove();

        let refreshButton = new Widget({
            parentNode: this._emoteListNode,
            html: `
                <button class="emote-button refresh-button material-symbols-outlined">refresh</button>
            `,
        });
        refreshButton.root.addEventListener("click", async(e) => EmoteList.refresh());

        let emoteIds = EmoteList.emotes.map(e => e.id.toString());

        // Sort emote IDs by most recently used first.
        let recentlyUsed = getRecentlyUsedEmotes();
        emoteIds.sort((a, b) => {
            let aTime = recentlyUsed[a] ?? 0;
            let bTime = recentlyUsed[b] ?? 0;
            return bTime - aTime;
        });
        
        // Add recently used emotes first.
        for(let emoteId of emoteIds)
        {
            let emoteInfo = EmoteList.emotes.find(e => e.id.toString() === emoteId);
            if(this.filter != "" && emoteInfo.name.toLowerCase().indexOf(this.filter) === -1)
                continue;

            let emoteButton = new Widget({
                parentNode: this._emoteListNode,
                html: `
                    <button class="emote-button"><img></button>
                `,
            });

            emoteButton.root.title = emoteInfo.name;
            emoteButton.root.dataset.emoteId = emoteInfo.id;
            emoteButton.root.querySelector("img").src = emoteInfo.path;
            emoteButton.root.querySelector("img").alt = emoteInfo.name;
        }
    }
}
